export enum TakePlace {
  WILL_TAKE_PLACE = 'Состоится',
  TOOK_PLACE = 'Состоялся',
}

export enum TakeRecord {
  ROOMS = 'Посмотреть вебинар',
  RECORD = 'Посмотреть запись',
}



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/compopnents/block/components/legend/components/roomsblock/types.ts